"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingTypeAccount = exports.VestingTypeAccessor = exports.AssociatedTokenAccount = exports.AssociatedTokenAccessor = exports.TokenPoolAccount = exports.TokenPoolAccessor = exports.VestingAccount = exports.VestingAccessor = exports.ConfigAccount = exports.ConfigAccessor = exports.AccountWithSeed = exports.Account = exports.VestingAccountAccessor = exports.AccountAccessor = void 0;
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var borsh_1 = require("@solvei/borsh");
var schema_1 = require("@solvei/borsh/schema");
var models_1 = require("./models");
var utils_1 = require("./utils");
var AccountAccessor = /** @class */ (function () {
    function AccountAccessor(context) {
        this.context = context;
    }
    AccountAccessor.prototype.existing = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get.apply(this, params)];
                    case 1:
                        account = _a.sent();
                        if (account.storage === null) {
                            throw Error("".concat(account.getName(), " does not exist"));
                        }
                        return [2 /*return*/, account];
                }
            });
        });
    };
    AccountAccessor.prototype.nonExisting = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get.apply(this, params)];
                    case 1:
                        account = _a.sent();
                        if (account.storage !== null) {
                            throw Error("".concat(account.getName(), " already exist"));
                        }
                        return [2 /*return*/, account];
                }
            });
        });
    };
    return AccountAccessor;
}());
exports.AccountAccessor = AccountAccessor;
var VestingAccountAccessor = /** @class */ (function (_super) {
    __extends(VestingAccountAccessor, _super);
    function VestingAccountAccessor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VestingAccountAccessor.prototype.get = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var pubkey, storage, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPublicKey.apply(this, params)];
                    case 1:
                        pubkey = _a.sent();
                        return [4 /*yield*/, this.context.connection.getAccountInfo(pubkey)];
                    case 2:
                        storage = _a.sent();
                        data = storage && this.deserialize(storage);
                        return [2 /*return*/, new this.accountConstructor(this.context, params, data, storage, pubkey, this.getSeed.apply(this, params))];
                }
            });
        });
    };
    return VestingAccountAccessor;
}(AccountAccessor));
exports.VestingAccountAccessor = VestingAccountAccessor;
var Account = /** @class */ (function () {
    function Account(context, params, data, storage, pubkey) {
        this.context = context;
        this.params = params;
        this.data = data;
        this.storage = storage;
        this.pubkey = pubkey;
    }
    Account.prototype.getAccountMeta = function () {
        return {
            pubkey: this.pubkey,
            isSigner: false,
            isWritable: false,
        };
    };
    Account.prototype.getWritableAccountMeta = function () {
        return {
            pubkey: this.pubkey,
            isSigner: false,
            isWritable: true,
        };
    };
    return Account;
}());
exports.Account = Account;
var AccountWithSeed = /** @class */ (function (_super) {
    __extends(AccountWithSeed, _super);
    function AccountWithSeed(context, params, data, storage, pubkey, seed) {
        var _this = _super.call(this, context, params, data, storage, pubkey) || this;
        _this.seed = seed;
        return _this;
    }
    AccountWithSeed.prototype.getCreateInstruction = function () {
        return __awaiter(this, void 0, void 0, function () {
            var space, lamports;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        space = this.createContext.space;
                        return [4 /*yield*/, this.context.connection.getMinimumBalanceForRentExemption(space)];
                    case 1:
                        lamports = _a.sent();
                        return [2 /*return*/, web3_js_1.SystemProgram.createAccountWithSeed({
                                fromPubkey: this.context.sender,
                                basePubkey: this.context.sender,
                                newAccountPubkey: this.pubkey,
                                lamports: lamports,
                                space: space,
                                programId: this.createContext.owner == "program"
                                    ? this.context.programId
                                    : spl_token_1.TOKEN_PROGRAM_ID,
                                seed: this.seed,
                            })];
                }
            });
        });
    };
    return AccountWithSeed;
}(Account));
exports.AccountWithSeed = AccountWithSeed;
var ConfigAccessor = /** @class */ (function (_super) {
    __extends(ConfigAccessor, _super);
    function ConfigAccessor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountConstructor = ConfigAccount;
        return _this;
    }
    ConfigAccessor.prototype.getSeed = function () {
        return "config";
    };
    ConfigAccessor.prototype.deserialize = function (account) {
        return (0, borsh_1.deserialize)((0, schema_1.generateSchemas)([models_1.Config]), models_1.Config, account.data);
    };
    ConfigAccessor.prototype.getPublicKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(this.context.creator, this.getSeed(), this.context.programId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ConfigAccessor;
}(VestingAccountAccessor));
exports.ConfigAccessor = ConfigAccessor;
var ConfigAccount = /** @class */ (function (_super) {
    __extends(ConfigAccount, _super);
    function ConfigAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createContext = { space: models_1.Config.space, owner: "program" };
        return _this;
    }
    ConfigAccount.prototype.getName = function () {
        return "Config Account";
    };
    return ConfigAccount;
}(AccountWithSeed));
exports.ConfigAccount = ConfigAccount;
var VestingAccessor = /** @class */ (function (_super) {
    __extends(VestingAccessor, _super);
    function VestingAccessor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountConstructor = VestingAccount;
        return _this;
    }
    VestingAccessor.prototype.getSeed = function (receiver) {
        return (0, utils_1.getSeed)(this.context.programId.toBase58(), "VestingAccount", this.context.vestingName, receiver.toBase58());
    };
    VestingAccessor.prototype.getPublicKey = function (receiver) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(this.context.vestingsCreator, this.getSeed(receiver), this.context.programId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    VestingAccessor.prototype.deserialize = function (account) {
        return (0, borsh_1.deserialize)((0, schema_1.generateSchemas)([models_1.Vesting]), models_1.Vesting, account.data);
    };
    return VestingAccessor;
}(VestingAccountAccessor));
exports.VestingAccessor = VestingAccessor;
var VestingAccount = /** @class */ (function (_super) {
    __extends(VestingAccount, _super);
    function VestingAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createContext = { space: models_1.Vesting.space, owner: "program" };
        return _this;
    }
    VestingAccount.prototype.getName = function () {
        return "Vesting Account for ".concat(this.params[0].toBase58());
    };
    return VestingAccount;
}(AccountWithSeed));
exports.VestingAccount = VestingAccount;
var TokenPoolAccessor = /** @class */ (function (_super) {
    __extends(TokenPoolAccessor, _super);
    function TokenPoolAccessor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenPoolAccessor.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pubkey, storage, data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getPublicKey()];
                    case 1:
                        pubkey = _b.sent();
                        return [4 /*yield*/, this.context.connection.getAccountInfo(pubkey)];
                    case 2:
                        storage = _b.sent();
                        _a = storage;
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.deserialize(pubkey)];
                    case 3:
                        _a = (_b.sent());
                        _b.label = 4;
                    case 4:
                        data = _a;
                        return [2 /*return*/, new TokenPoolAccount(this.context, [], data, storage, pubkey, this.getSeed())];
                }
            });
        });
    };
    TokenPoolAccessor.prototype.getSeed = function () {
        return (0, utils_1.getSeed)(this.context.programId.toBase58(), "TokenPool", this.context.vestingName);
    };
    TokenPoolAccessor.prototype.getPublicKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(this.context.creator, this.getSeed(), spl_token_1.TOKEN_PROGRAM_ID)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TokenPoolAccessor.prototype.deserialize = function (pubkey) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = new spl_token_1.Token(this.context.connection, this.context.mint, spl_token_1.TOKEN_PROGRAM_ID, null // signer is required but isn't used
                        );
                        return [4 /*yield*/, token.getAccountInfo(pubkey)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TokenPoolAccessor;
}(AccountAccessor));
exports.TokenPoolAccessor = TokenPoolAccessor;
var TokenPoolAccount = /** @class */ (function (_super) {
    __extends(TokenPoolAccount, _super);
    function TokenPoolAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createContext = { space: spl_token_1.AccountLayout.span, owner: "token" };
        return _this;
    }
    TokenPoolAccount.prototype.getName = function () {
        return "Token Pool Account";
    };
    TokenPoolAccount.prototype.getInitInstruction = function () {
        return spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, this.context.mint, this.pubkey, this.context.creator);
    };
    TokenPoolAccount.prototype.getTransferInstruction = function (fromPubkey, amountLamorts) {
        return spl_token_1.Token.createTransferInstruction(spl_token_1.TOKEN_PROGRAM_ID, fromPubkey, this.pubkey, this.context.creator, [], new spl_token_1.u64(amountLamorts.toString()));
    };
    return TokenPoolAccount;
}(AccountWithSeed));
exports.TokenPoolAccount = TokenPoolAccount;
var AssociatedTokenAccessor = /** @class */ (function (_super) {
    __extends(AssociatedTokenAccessor, _super);
    function AssociatedTokenAccessor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AssociatedTokenAccessor.prototype.get = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var pubkey, storage, data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getPublicKey(params)];
                    case 1:
                        pubkey = _b.sent();
                        return [4 /*yield*/, this.context.connection.getAccountInfo(pubkey)];
                    case 2:
                        storage = _b.sent();
                        _a = storage;
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.deserialize(pubkey)];
                    case 3:
                        _a = (_b.sent());
                        _b.label = 4;
                    case 4:
                        data = _a;
                        return [2 /*return*/, new AssociatedTokenAccount(this.context, params, data, storage, pubkey)];
                }
            });
        });
    };
    AssociatedTokenAccessor.prototype.getPublicKey = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, this.context.mint, params[0], true)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AssociatedTokenAccessor.prototype.deserialize = function (pubkey) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = new spl_token_1.Token(this.context.connection, this.context.mint, spl_token_1.TOKEN_PROGRAM_ID, null // signer is required but isn't used
                        );
                        return [4 /*yield*/, token.getAccountInfo(pubkey)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AssociatedTokenAccessor;
}(AccountAccessor));
exports.AssociatedTokenAccessor = AssociatedTokenAccessor;
var AssociatedTokenAccount = /** @class */ (function (_super) {
    __extends(AssociatedTokenAccount, _super);
    function AssociatedTokenAccount() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AssociatedTokenAccount.prototype.getName = function () {
        return "Associated Token Account for ".concat(this.params[0].toBase58());
    };
    AssociatedTokenAccount.prototype.getCreateInstruction = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, this.context.mint, this.pubkey, this.params[0], this.context.sender)];
            });
        });
    };
    return AssociatedTokenAccount;
}(Account));
exports.AssociatedTokenAccount = AssociatedTokenAccount;
var VestingTypeAccessor = /** @class */ (function (_super) {
    __extends(VestingTypeAccessor, _super);
    function VestingTypeAccessor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountConstructor = VestingTypeAccount;
        return _this;
    }
    VestingTypeAccessor.prototype.getSeed = function () {
        return (0, utils_1.getSeed)(this.context.programId.toBase58(), "VestingType", this.context.vestingName);
    };
    VestingTypeAccessor.prototype.deserialize = function (account) {
        return (0, borsh_1.deserialize)((0, schema_1.generateSchemas)([models_1.VestingType]), models_1.VestingType, account.data);
    };
    VestingTypeAccessor.prototype.getPublicKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(this.context.creator, this.getSeed(), this.context.programId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return VestingTypeAccessor;
}(VestingAccountAccessor));
exports.VestingTypeAccessor = VestingTypeAccessor;
var VestingTypeAccount = /** @class */ (function (_super) {
    __extends(VestingTypeAccount, _super);
    function VestingTypeAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createContext = { space: models_1.VestingType.space, owner: "program" };
        return _this;
    }
    VestingTypeAccount.prototype.getName = function () {
        return "Vesting Type Account";
    };
    VestingTypeAccount.prototype.getTokenPoolPdaAccountMeta = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pda;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.findProgramAddress([this.pubkey.toBuffer()], this.context.programId)];
                    case 1:
                        pda = (_a.sent())[0];
                        return [2 /*return*/, {
                                pubkey: pda,
                                isSigner: false,
                                isWritable: false,
                            }];
                }
            });
        });
    };
    VestingTypeAccount.prototype.getMultisigTokenPdaAccountMeta = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pda;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.findProgramAddress([this.pubkey.toBuffer(), Buffer.from("multisig", "utf8")], this.context.programId)];
                    case 1:
                        pda = (_a.sent())[0];
                        return [2 /*return*/, {
                                pubkey: pda,
                                isSigner: false,
                                isWritable: false,
                            }];
                }
            });
        });
    };
    return VestingTypeAccount;
}(AccountWithSeed));
exports.VestingTypeAccount = VestingTypeAccount;
//# sourceMappingURL=accounts.js.map